import styled, { css } from 'styled-components'
import BaseInput from 'components/Input'
import { ReactComponent as BaseLinkIcon } from 'icons/link-12.svg'
import { ReactComponent as BasePersonIcon } from 'icons/person-12.svg'
import Button from 'components/Button'
import BaseForm from 'components/Form'
import { Truncate, truncateStyles } from 'components/Truncate'
import { dropdownItemStyles } from 'components/Dropdown/Item'
import { popoverStyles } from 'components/Popover/Content/PopoverContent'
import Avatar from 'components/Avatar'
import { ToggleWrapper } from '../AccessLevelSelect'

const InvitePeopleContent = styled.div`
  overflow: visible;
`

const InvitePeopleInputWrapper = styled.div`
  align-items: center;
  height: 40px;
  border-radius: 4px;
`

// Width of the invite field + add button
// for handling autocomplete items overflow
const InvitePeopleFieldWrapper = styled.div`
  max-width: 346px;
`

const LinkInviteInput = styled(BaseInput)`
  height: 40px;

  &[type='text'] {
    font-size: ${({ theme }) => theme.fontSizes.smaller};
    ${truncateStyles};

    :disabled {
      background-color: ${({ theme }) =>
        theme.colors.background.light.secondary};
    }
  }
`

const InvitePeopleIconWrapper = styled.div`
  position: absolute;
  display: flex;
  width: 40px;
  height: 40px;

  align-items: center;
  justify-content: center;

  /* stylelint-disable-line scales/space */
  left: -1px;
  top: 0;
  z-index: 1;
`

const InvitePeopleInput = styled(LinkInviteInput)`
  &[type='text'] {
    /* The size of the permissions selector */
    padding-right: 119px; /* stylelint-disable-line scales/space */
    padding-left: 40px;
  }
`

const InvitePeopleInputCombobox = styled.div`
  position: absolute;
  width: 100%;

  &.value-selected {
    font-weight: bold;

    ${InvitePeopleInput} {
      font-weight: bold;
    }

    /* This is for displaying the '@' inside the input before the user name when selected
     from the dropdown */
    &::before {
      content: '@';
      position: absolute;
      z-index: 1;
      padding: 10px 0 10px 30px; /* stylelint-disable-line scales/space */
      font-weight: bold;
    }
  }
`

const AccessLevelSelectInvite = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  bottom: 0;

  /* stylelint-disable-next-line no-descending-specificity */
  & ${ToggleWrapper} {
    width: 115px;
    border: none;
    box-shadow: none;
  }
`

const iconStyles = css`
  width: 12px;
  min-width: 12px;
  height: 12px;
  min-height: 12px;
  color: ${({ theme }) => theme.colors.text.dark.secondary};
`

const LinkIcon = styled(BaseLinkIcon)`
  ${iconStyles}
`

const PersonIcon = styled(BasePersonIcon)`
  ${iconStyles}
`

const MemberInviteForm = styled(BaseForm)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
`

const EmailField = styled(BaseForm.Field)`
  flex: 1;
  margin-right: 12px;
  z-index: 1;
`

const InviteButton = styled(Button).attrs({ variant: 'primary' })`
  min-height: 40px;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  min-width: 82px;
`

const AutocompleteList = styled.ul`
  ${popoverStyles};

  margin-top: 4px;

  &:empty {
    display: none;
  }
`

const AutocompleteItemContent = styled(Truncate)`
  display: flex;
  align-items: center;
`

const AutocompleteItemAvatar = styled(Avatar)`
  margin-right: 8px;
  min-width: 28px; /* Tweak for flex children with width: 0; */
`

const PrimaryText = styled(Truncate)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text.dark.base};
  margin-bottom: 4px;
`

const SecondaryText = styled(Truncate)`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.text.dark.secondary};
`

const AutocompleteItem = styled.li`
  ${dropdownItemStyles};

  padding-left: 12px;
  padding-right: 12px;
`

const AutocompleteItemText = styled.div`
  /* This is for the children to overflow. 100% - width of the Avatar */
  width: calc(100% - 28px);
`

export {
  InvitePeopleContent,
  InvitePeopleFieldWrapper,
  InvitePeopleInputWrapper,
  InvitePeopleInputCombobox,
  InvitePeopleIconWrapper,
  InvitePeopleInput,
  LinkInviteInput,
  AccessLevelSelectInvite,
  LinkIcon,
  PersonIcon,
  MemberInviteForm,
  EmailField,
  InviteButton,
  AutocompleteList,
  AutocompleteItem,
  AutocompleteItemAvatar,
  AutocompleteItemContent,
  AutocompleteItemText,
  PrimaryText,
  SecondaryText,
}
